export default "__VITE_ASSET__BIb7wdUR__"